import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import { getFormalTWDateTime } from "@/helper/dateHelper";

import GroupDashboard from "./GroupDashboard";
import StoreDashboard from "./StoreDashboard";
import classNames from "classnames";
import { useUserProfileContext } from "@/context/UserProfileContext";

enum TabsEnum {
  Group = "全品牌",
  Store = "分店",
}

type Tabs = keyof typeof TabsEnum;

type Props = ReduxProps<typeof connector>;

const DashboardApp: React.FC<Props> = ({ groupUpdateAt, storeUpdateAt }) => {
  const [tab, setTab] = useState<Tabs>("Group");
  const [key, setKey] = useState<number>(Date.now());
  const { group } = useUserProfileContext();

  useEffect(() => {
    setKey(Date.now());
  }, [group?.id]);

  const uiContent = () => {
    switch (tab) {
      case "Group":
        return <GroupDashboard />;
      case "Store":
        return <StoreDashboard />;
      default:
        return null;
    }
  };

  const uiUpdateAt = () => {
    switch (tab) {
      case "Group":
        return groupUpdateAt;
      case "Store":
        return storeUpdateAt;
      default:
        return null;
    }
  };

  return (
    <section key={key} className="dashboard">
      <h2 className="heading__2 heading__2--title dashboard__heading">
        <span className="heading__2--icon">
          <FontAwesomeIcon icon={["far", "tachometer-fast"]} />
        </span>
        主控台
        <span className="dashboard__updateAt tiny">
          <FontAwesomeIcon icon={["far", "exclamation-circle"]} /> 更新時間：
          {getFormalTWDateTime(uiUpdateAt()!)}
        </span>
      </h2>
      <ul
        className={"flex lg:w-max mb-8 text-grey-2 rounded-lg overflow-hidden"}
      >
        {Object.keys(TabsEnum).map((tabName) => {
          const isActive = tab === tabName;

          return (
            <li
              key={tabName}
              onClick={() => setTab(tabName as Tabs)}
              className={classNames(
                "w-full lg:w-auto",
                "py-3 lg:px-16",
                "text-center",
                "bg-white",
                "hover:cursor-pointer",
                {
                  "bg-primary-pink text-white font-semibold": isActive,
                }
              )}
            >
              {TabsEnum[tabName as Tabs]}
            </li>
          );
        })}
      </ul>
      <div>{uiContent()}</div>
    </section>
  );
};

const mapStateToProps = (state: RootState) => ({
  groupUpdateAt: state.dashboard.group.whole.updatedAt,
  storeUpdateAt: state.dashboard.store.whole.updatedAt,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(DashboardApp);
